export default __webpack_public_path__ + "static/media/movieImage.6c36ae2d.jpg";